<style lang="less">
  // @import '../flow.less';
  @import '../flow.less';
</style>

<template>
  <div>
  <Card>
      <Row>
        <i-col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="90" @submit.native.prevent>
            <FormItem label="申请人/项目名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入申请人/项目名"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getMemFlowsList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="6">
          <Button style="float: right;" v-show="isMemflowAdd"  @click="AddSvnFlow()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加成员变更</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getMemFlowsList"></page>
        </div>
     </Row>
      <Drawer
        title="添加成员变更"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="70" :rules="ruleValidate">
          <form-item label="项目" prop="project">
             <i-select v-model="formItem.project" @on-change="handleProjectOnChange">
              <i-option v-for="item in projectOptions" :value="item" :key="item" :label="item"></i-option>
             </i-select>
          </form-item>
           <form-item label="成员类型" prop="category">
             <i-select v-model="formItem.category" >
                <i-option value="masters" label="项目经理"></i-option>
                <i-option value="developers" label="开发人员"></i-option>
                <i-option value="pms" label="产品经理"></i-option>
                <i-option value='tests' label="测试人员"></i-option>
                <i-option value="maintain" label="维护人员"></i-option>
             </i-select>
          </form-item>
          <form-item label="项目经理" prop="step_0">
             <i-select v-model="formItem.step_0" filterable  multiple disabled>
               <i-option v-for="item in formItem.step_0" :value="item" :key="item" :label="item"></i-option>
             </i-select>
          </form-item>
          <!-- <FormItem
                v-for="(item, index) in formItem.steps"
                :key="index"
                :label="item.name"
                :prop="'steps.' + index + '.users_sel'"
                :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
             <i-select v-model="item.users_sel"  multiple>
               <i-option v-for="user in item.users_all" :value="user" :key="user" :label="user"></i-option>
             </i-select>
          </FormItem> -->
           <form-item label="提交描述" prop="description" >
            <i-input  v-model="formItem.description" placeholder="请输入项目描述信息" type="textarea"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getList, saveMemberFlow } from '@/api/memflow'
import { getMemJob } from '@/api/job'
import { fetchProjectInfoData, getNameList } from '@/api/project'
// import { forEach } from '@/libs/tools'
// import config from '@/config'
export default {
  name: 'MemberList',
  components: {
    Tables
  },
  data () {
    var that = this
    return {
      isMemflowAdd: false,
      project_type_show: false,
      change: false,
      count: 1,
      size: 10,
      page: 1,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '申请者', key: 'user', align: 'center', minWidth: 100 },
        { title: '项目', key: 'project', align: 'center', minWidth: 100 },
        { title: '成员类型', key: 'category', align: 'center', minWidth: 100 },
        { title: '申请时间', key: 'time_start', align: 'center', sortable: 'custom', minWidth: 150 },
        { title: '完成时间', key: 'time_end', align: 'center', sortable: 'custom', minWidth: 150 },
        {
          title: '状态',
          key: 'status_verbose',
          align: 'center',
          minWidth: 100,
          sortable: 'custom',
          filters: [
            {
              label: '开始',
              value: 'start'
            },
            {
              label: '待审',
              value: 'todo'
            },
            {
              label: '通过',
              value: 'agree'
            },
            {
              label: '完成',
              value: 'done'
            },
            {
              label: '出错',
              value: 'error'
            },
            {
              label: '拒绝',
              value: 'refuse'
            },
            {
              label: '取消',
              value: 'cancel'
            },
            {
              label: '构建失败',
              value: 'fail'
            },
            {
              label: '已回滚',
              value: 'back'
            }
          ],
          filterMultiple: false,
          filterRemote (value, row) {
            if (value.length > 0) {
              that.status = value[0]
            } else {
              that.status = null
            }
            that.getMemFlowsList()
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({name: 'MemberDetail', query: {id: params.row.id}})
                    // this.$router.push({path: '/SvnFlow/SvnFlowDetail', query: {id: params.row.id}})
                  }
                }
              }, '详情'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要取消吗?',
                  transfer: true
                },
                on: {
                  'on-ok': () => {
                    this.handleCancel(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: this.$store.state.user.superuser && ['start', 'todo', 'doing'].indexOf(params.row.status) < 0
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, '取消')
              ])
            ])
          }
        }
      ],
      tableData: [],
      commitOptionsRollback: [],
      rollbackCommit: null,
      projectOptions: [],
      changefiles: [],
      loading_filelist: false,
      disabled_filelist: false,
      changeLoadingShow: false,
      formItem: {
        project: '',
        step_0: [],
        versions: '',
        files: '',
        level: 'normal',
        description: '',
        steps: [
          {
            id: null,
            name: '',
            group: null,
            users: [],
            users_all: [],
            users_sel: [],
            order: null,
            type: ''
          }
        ]
      },
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        project: [
          { required: true, message: '项目不能为空 !', trigger: 'change' }
        ],
        step_0: [
          { required: true, message: '步骤审批人不能为空', trigger: 'change', type: 'array' }
        ],
        // files: [
        //   { required: true, message: '提交文件不能为空 !', trigger: 'change' }
        // ],
        description: [
          { required: true, message: '描述信息不能为空 !', trigger: 'blur' }
        ]
        // versions: [
        //   { required: true, message: '版本号不能为空 !', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_memberflow') > -1) {
        this.isMemflowAdd = true
      } else {
        this.isMemflowAdd = false
      }
    },
    // 添加SvnFlow ，打开抽屉，并且加载Form初始化数据
    AddSvnFlow () {
      this.change = true
      this.InitFormData()
    },
    InitFormData () {
      this.getProjectOptions()
      // 初始化审批步骤Form-Item
      // this.handleAddFormItem()
      this.fetchMemJobData()
    },
    fetchChangeFileList () {
      if (this.formItem.project === '') {
        this.$Message.error('请先选择项目')
        return
      }
      if (this.formItem.versions === '') {
        this.$Message.error('请填svn提交版本号')
        return
      }
      this.loading_filelist = true
      let data = {
        project: this.formItem.project,
        versions: this.formItem.versions
      }
      fetchChangeFileList(data).then(res => {
        if (!res.data.data.length) {
          this.$Message.error({content: '找不到当前版本号相关信息，请核查版本号是否正确', duration: 6})
          this.loading_filelist = false
        } else {
          if (res.data.data instanceof Array) {
            this.changefiles = res.data.data
            // 对最终表单要提交的文件 赋值
            this.formItem.files = this.changefiles.join('')
            this.loading_filelist = false
            this.disabled_filelist = true
          }
        }
      })
    },
    fetchMemJobData () {
      getMemJob().then(res => {
        if (res.data.steps instanceof Array) {
          let steps = res.data.steps
          if (res.data.ordered) {
            steps.sort(function (a, b) {
              return a.order - b.order
            })
          }
          this.formItem.steps = steps
        }
      })
    },
    handleProjectOnChange (value) {
      this.formItem.step_0 = []
      if (value) {
        this.fetchProjectInfoData(value)
      }
      this.formItem.versions = ''
      this.formItem.files = ''
      this.changefiles = []
      this.disabled_filelist = false
      this.loading_filelist = flase
    },
    fetchProjectInfoData (value) {
      fetchProjectInfoData(value).then(res => {
        this.formItem.step_0 = res.data.masters
      })
    },
    getMemFlowsList (value = 1) {
      this.page = value

      let params = {
        page: this.page,
        ordering: this.ordering,
        status: this.status,
        search: this.searchForm.name
      }
      getList(params).then(res => {
        this.tableData = res.data.results
        this.tableData.map((item, index) => {
          item['num'] = item.build_id ? '#' + item.build_id : ''
        })
        this.count = res.data.count
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      } else if (column.key === 'time_start') {
        if (column.order === 'asc') {
          this.ordering = 'time_start'
        } else {
          this.ordering = '-time_start'
        }
      } else if (column.key === 'time_end') {
        if (column.order === 'asc') {
          this.ordering = 'time_end'
        } else {
          this.ordering = '-time_end'
        }
      } else if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status_code'
        } else {
          this.ordering = '-status_code'
        }
      }
      this.getMemFlowsList()
    },
    drawerClose () {
      let that = this.formItem
      that.project = ''
      that.step_0 = []
      that.versions = ''
      that.files = ''
      that.description = ''
      that.level = 'normal'
    },
    searchReset () {
      this.searchForm.name = null
    },
    getProjectOptions () {
      getNameList().then(res => {
        this.projectOptions = res.data
      })
    },
    handleCancel (params) {
      cancelSvnFlow(params.row.id).then(res => {
        if (res.status === 204) {
          this.$Message.success('取消Svn工作流成功')
          this.getMemFlowsList()
        }
      })
    },
    // 取可供回滚的versions id 列表
    fetchRollbackVersionsList (id) {
      fetchRollbackVersionsList(id).then(res => {
        if (res.data instanceof Array) {
          this.commitOptionsRollback = res.data
        }
      })
    },
    handleRollback (params) {
      // 取所有版本供回滚 选择
      this.fetchRollbackVersionsList(params.row.id, params.row.project)
      // 弹出回滚版本选择框
      this.$Modal.confirm({
        width: '500px',
        title: '回滚版本',
        onOk: () => {
          if (this.rollbackCommit) {
            this.do_rollback_request(params.row.id, this.rollbackCommit)
          } else {
            this.$Message.error('请选择回滚版本号')
          }
        },
        render: (h) => {
          return h('div', [
            h('span', {style: {color: '#515a6e'}}, '请选择回滚版本号：'),
            h('Select', {
              props: {
                value: this.rollbackCommit
              },
              on: {
                'on-change': (value) => {
                  this.rollbackCommit = value
                }
              },
              style: {
                width: '200px'
              }
            },
            this.commitOptionsRollback.map(function (item) {
              return h('Option', {
                props: {value: item}
              }, item)
            })
            )
          ])
        }
      })
    },
    // 发起回滚请求
    do_rollback_request (id, commit) {
      rollbackSvnFlow(id, commit).then(res => {
        if (res.status === 200) {
          this.$Message.success(res.data.message)
        } else if (res.data.status === 502) {
          this.$Message.error('构建超时,请重新构建')
        } else {
          this.$Message.error(res.data.message)
        }
        // 刷新页面
        this.getGitFlowsList()
      })
    },
    handleSubmit (name) {
      // let that = this.formItem
      console.log(this.formItem)
      this.$refs[name].validate((valid) => {
        if (valid) {
          // forEach(this.formItem.steps, (item, index) => {
          //   let stepName = 'step_' + (index + 1)
          //   if (item.users_sel instanceof Array) {
          //     this.formItem[stepName] = item.users_sel
          //   }
          // })
          // 消息暂时写死只传站内信
          this.formItem['messageKey'] = {sms: '0', dingding: '0', wechat: '0', email: '0', message: '1'}
          this.changeLoadingShow = true
          saveMemberFlow(this.formItem).then(res => {
            if (res.data.id > 0) {
              // 跳转到详情页面
              this.change = false
              this.$router.push({name: 'MemberDetail', query: {id: res.data.id}})
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.message)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getMemFlowsList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
